
const items = [
    { title: "База лица", url:"/mycourses/emotions/1", chapter_id:91, state: ""},
    { title: "Улыбка", url:"/mycourses/emotions/2", chapter_id:92, state: ""},
    { title: "Обида", url:"/mycourses/emotions/3", chapter_id:93, state: ""},
    { title: "Удивление", url:"/mycourses/emotions/4", chapter_id: 94, state: ""},
];

export default items;